import { createSelector } from 'reselect';
import { State } from 'redux/types';
import { videoZipRequestsByIdSelector } from '../entities';
import { hasClipSuggestionsBulkExportEnabledSelector } from '../pricing';
import { VideoZipRequestState } from './types';

const stateSelector = (state: State): VideoZipRequestState =>
  state.get('videoZipRequest');

export const zipRequestIdSelector = createSelector(
  stateSelector,
  videoZipRequestState => videoZipRequestState?.get('zipRequestId'),
);

export const isCreatingZipRequestSelector = createSelector(
  stateSelector,
  videoZipRequestState => videoZipRequestState?.get('isCreatingZipRequest'),
);

export const isFetchingZipRequestSelector = createSelector(
  stateSelector,
  videoZipRequestState => videoZipRequestState?.get('isFetchingZipRequest'),
);

export const isLoadingVideoZipRequestSelector = createSelector(
  isCreatingZipRequestSelector,
  isFetchingZipRequestSelector,
  (isCreatingZipRequest, isFetchingZipRequest) =>
    isCreatingZipRequest || isFetchingZipRequest,
);

export const currentVideoZipRequestSelector = createSelector(
  zipRequestIdSelector,
  videoZipRequestsByIdSelector,
  (zipRequestId, videoZipRequestsById) =>
    videoZipRequestsById?.get(zipRequestId?.toString()),
);

export const currentVideoZipRequestStatusSelector = createSelector(
  currentVideoZipRequestSelector,
  currentVideoZipRequest => currentVideoZipRequest?.get('status'),
);

export const currentVideoZipRequestDownloadInfoSelector = createSelector(
  hasClipSuggestionsBulkExportEnabledSelector,
  currentVideoZipRequestSelector,
  isLoadingVideoZipRequestSelector,
  (exportAvailable, currentVideoZipRequest, isLoadingVideoZipRequest) => {
    const zipFileDownloadUrl = currentVideoZipRequest?.get(
      'zipFileDownloadUrl',
    );
    const status = currentVideoZipRequest?.get('status');
    const hasVideoZipFile = status === 'completed' && !!zipFileDownloadUrl;
    const isExportingZipFile =
      status === 'processing' || isLoadingVideoZipRequest;

    return {
      zipFileDownloadUrl,
      status,
      hasVideoZipFile,
      isExportingZipFile,
      isAllowedToDownload:
        exportAvailable && hasVideoZipFile && !isExportingZipFile,
    };
  },
);
